module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/battle-payments-reward-50.20d55cf4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/battle-payments-reward-50.png
// module id = 3781
// module chunks = 11